import React from "react";
import { useTranslation } from "react-i18next";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description this page Dictionary Library's Size Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Size({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DICTIONARY.";

  return (
    <div>
      <div className="form-element">
        {t(label + "DICTIONARY-VARIABLE")}
        <VariablePicker
          action={action}
          inputName="dictionaryVariable"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={true}
          filter="dictionary"
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'dictionary' })}</em></small>
      </div>
      <div className="form-element">
      {t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={false}
        />
      </div>
    </div>
  );
}
